import React from "react";
import { EQUITY } from "../../../constants";
import InvestmentWrapper from "../common/InvestmentWrapper/InvestmentWrapper";

const Stocks = ({ history }) => {
	return <InvestmentWrapper type={EQUITY} history={history} />;
};

export default Stocks;
